module.exports = "/_next/static/images/img-super-benefit-3-56e7f3cfa1cad0f15e3db661bf3b2869.svg";